<template>
  <BgImageLayout>
    <q-inner-loading :showing="!provider" style="z-index: 1">
      <q-spinner color="secondary-1" size="2rem" />
    </q-inner-loading>

    <Grid gtr="auto auto 1fr" gap="var(--r-space-md)" class="full-height">
      <InfoCard :popup-items="popupItems" @delete="$emit('delete')">
        <template v-if="provider" #title>
          <Grid gaf="column" align-items="center" justify-content="start">
            <div class="text-subtitle-2 text-secondary-3 product-name">{{ provider.name }}</div>

            <EditIcon class="q-ml-sm cursor-pointer edit-icon" />
            <RPopupEdit :value="provider.name" title="Update name" @ok="updateField({ ...$event, field: 'name' })">
              <template v-slot="props">
                <RInput
                  v-model="props.model.value"
                  :disable="props.loading"
                  no-feedback-icon
                  no-hint
                  no-label
                  autofocus
                  on-clear="focus"
                  @keyup.enter.stop="updateField({ ...props, field: 'name' })"
                />
              </template>
            </RPopupEdit>
          </Grid>
        </template>

        <Grid v-if="provider" gtc="3fr 1fr" justify-content="space-between">
          <HeaderLabels :provider="provider" :create-data="createData" @update="updateField" />

          <div class="right-section text-right">
            <span class="text-body-3 text-primary-1">{{ provider.active_subscriptions_count }}</span>
            <span class="text-body-3 text-secondary-1 q-ml-xs">Active subscription</span>
            <div class="text-caption-1 text-secondary-1">worth</div>
            <div class="text-subtitle-1 text-secondary-1">
              {{ provider.subscription_value_local_currency }} {{ formatPrice(provider.subscription_value_local) }}
            </div>
          </div>
        </Grid>
      </InfoCard>

      <RouteTabs :tabs="tabs">
        <template v-slot="{ tab }">
          {{ tab.name }}
        </template>
      </RouteTabs>

      <keep-alive>
        <router-view v-if="provider" />
      </keep-alive>
    </Grid>
  </BgImageLayout>
</template>

<script>
// Libraries
import { mapActions, mapGetters, mapState } from 'vuex'
// Mixins
import { registerVuexModule } from '@/mixins/register-vuex-module'
// Components
import InfoCard from '@/ui/InfoCard'
import RPopupEdit from '@/ui/RPopupEdit'
import EditIcon from '@/ui/icons/EditIcon'
import RouteTabs from '@/ui/RouteTabs'
import HeaderLabels from './HeaderLabels'

export default {
  components: {
    InfoCard,
    RPopupEdit,
    EditIcon,
    RouteTabs,
    HeaderLabels
  },

  mixins: [registerVuexModule('provider-show', () => require('./vuex-module'))],

  props: {
    provider: Object,
    createData: Object,
    tabs: {
      type: Array,
      required: true
    }
  },

  computed: {
    popupItems() {
      return [{ name: 'delete', label: 'Delete', textColorClass: 'text-danger-1' }]
    },

    ...mapState('provider-show', ['contacts']),
    ...mapGetters('provider-show', ['primaryContact'])
  },

  methods: {
    ...mapActions('provider-show', ['getAndSetContacts', 'setPrimaryContact']),

    updateField(data) {
      if (data.field === 'is_primary') this.setPrimary(data)
      else this.$emit('update-field', data)
    },

    async setPrimary({ set, cancel, value: contactId, setLoading }) {
      if (!this.primaryContact && !contactId) {
        cancel()
        return
      }

      const contact = this.contacts.find(contact => contact.id === contactId)
      let payload

      if (contact) {
        payload = { ...contact, is_primary: true, provider_id: this.provider.id }
      } else {
        payload = { ...this.primaryContact, is_primary: false, provider_id: this.provider.id }
      }

      setLoading(true)

      await this.setPrimaryContact({ contactId: contactId || this.primaryContact.id, payload })
        .then(set)
        .catch(cancel)
        .finally(() => setLoading(false))
      this.getAndSetContacts(this.provider)
    }
  }
}
</script>

<style lang="scss" scoped></style>
